import React from 'react'
import {
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  Radio,
  FormControlLabel,
  RadioGroup,
  TextField,
  Box,
  InputAdornment,
  Divider,
} from '@mui/material'
import { OtherItem } from './OtherTrayItems.types'
import { UsageOtherItem } from 'views/DigitalTrayMapping/AssignedDigitalTrays/AssignedDigitalTrays.types'
import { OtherItemSelectorLogic } from './OtherItemSelector.logic'

interface OtherItemSelectorProps {
  open: boolean
  onClose: () => void
  otherItems: OtherItem[]
  onAddToUsage: (item: UsageOtherItem) => void
}

const OtherItemSelector: React.FC<OtherItemSelectorProps> = ({
  open,
  onClose,
  otherItems,
  onAddToUsage,
}) => {
  const {
    selectedItems,
    selectedStatus,
    handleItemSelect,
    handleStatusChange,
    handleQuantityChange,
    handleConfirm,
    selectedItemsCount,
  } = OtherItemSelectorLogic({ otherItems, onAddToUsage, onClose })

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle variant="h2">Add Other Items</DialogTitle>
      <DialogContent>
        <List>
          {otherItems.map((item) => (
            <ListItem
              key={item.device_id}
              button
              onClick={() => handleItemSelect(item)}
              selected={!!selectedItems[item.device_id]}
              secondaryAction={
                selectedItems[item.device_id] && (
                  <Box sx={{ width: 80 }}>
                    <TextField
                      type="number"
                      size="small"
                      value={selectedItems[item.device_id].quantity}
                      onChange={(e) =>
                        handleQuantityChange(
                          item,
                          e as React.ChangeEvent<HTMLInputElement>
                        )
                      }
                      InputProps={{
                        inputProps: {
                          min: 1,
                          max: item.count,
                          style: { textAlign: 'center' },
                        },
                        endAdornment: (
                          <InputAdornment position="end">
                            /{item.count}
                          </InputAdornment>
                        ),
                      }}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </Box>
                )
              }
            >
              <Checkbox
                checked={!!selectedItems[item.device_id]}
                edge="start"
                onClick={(e) => e.stopPropagation()}
              />
              <ListItemText
                primary={item.label}
                secondary={`${item.device_description} (Available: ${item.count})`}
              />
            </ListItem>
          ))}
        </List>

        {selectedItemsCount > 0 && (
          <>
            <Divider sx={{ my: 2 }} />
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1">
                Set status for all selected items:
              </Typography>
              <RadioGroup
                value={selectedStatus}
                onChange={handleStatusChange}
                row
              >
                <FormControlLabel
                  value="implanted"
                  control={<Radio />}
                  label="Implanted"
                />
                <FormControlLabel
                  value="wasted"
                  control={<Radio />}
                  label="Wasted"
                />
              </RadioGroup>
            </Box>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="primary"
          disabled={selectedItemsCount === 0}
        >
          Add {selectedItemsCount} {selectedItemsCount === 1 ? 'Item' : 'Items'}{' '}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default OtherItemSelector
